



































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import Input from '@/components/Input.vue';
import { namespace } from 'vuex-class';
import { BottomWrapper } from '../../BottomWrapper.vue';
import { BetHistoryEntity, BetHistoryEntitySelection } from '@/common/api/model';
import { OrderType, SYSTEM_MESSAGE_PREFIX, TransactionType } from '@/common/config';
import { stepEnum } from '@/views/Chatroom/model';
import { round } from '@/common/utils';
import { TransactionInputEvent } from '@/common/types';
import FaCheckSquare from '@/components/icons/FaCheckSquare.vue';
import FaRegSquare from '@/components/icons/FaRegSquare.vue';
import RadioFilled from '@/components/icons/RadioFilled.vue';
import RadioEmpty from '@/components/icons/RadioEmpty.vue';
import { checkBetTransactionWarning, isUnsettledBet } from '@/common/transaction-utils';
import { ConnectToAgent } from '@/common/bot/types';
import TransactionItemWarning from './TransactionItemWarning.vue';
import { reportingService } from '@/common/reporting';
import * as PleasedApi from '@/common/api/api.pleased';
import * as PleasedModel from '@/common/api/models.pleased';
import { ChatWarnings } from '@/store/chatWarning/chatWarning.types';

const userModule = namespace('user');
const chatModule = namespace('chat');
const chatWarning = namespace('chatWarning');

const getTitile = (firstSelection: BetHistoryEntitySelection) => {
  const isOutright = firstSelection.eventId.includes('match');
  return isOutright ? `${firstSelection.home} vs ${firstSelection.away}` : firstSelection.tournamentName;
};

@Component({
  components: {
    TransactionItemWarning,
    Input,
    BottomWrapper,
    FaCheckSquare,
    FaRegSquare,
    RadioFilled,
    RadioEmpty,
  },
  filters: {
    formatDate (value: any) {
      const options = { hour12: false, month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' } as const;
      const date = new Date(value);
      return date.toLocaleString(undefined, options);
    },
    getTitile (firstSelection: BetHistoryEntitySelection) {
      return getTitile(firstSelection);
    },
  },
})
export default class BetTransaction extends Vue {
  @Prop({ default: () => ([]) }) readonly transactions!: BetHistoryEntity[];
  @Prop({ default: null }) readonly transactionsSavedData: TransactionInputEvent | null = null
  @Prop({ default: '' }) readonly transactionType!: TransactionType
  @Prop() readonly connectConfig!: ConnectToAgent | null;

  @Prop({ default: () => [] }) readonly openRequestFields!: PleasedModel.TicketField[];
  @Prop({ default: () => ({ subject: '', description: '', email: '' }) }) readonly requestInfo!: { subject: string, description: string, email: string };
  @Prop({ default: () => [] }) readonly userSelections!: {message: string; timestamp: string}[]

  @userModule.Getter('currency') currency!: string;
  @chatModule.Mutation('updateExtraTransactionInfo') updateExtraTransactionInfo!: Function;
  @chatWarning.Getter('chatWarnings') chatWarnings!: ChatWarnings;

  winningStatusMap = {
    0: 'Running',
    5: 'Partial Win',
    20: 'Won',
    30: 'Lost',
    40: 'Void',
    90: 'Pending',
  };
  orderTypeMap = OrderType;
  selectedTransIssue: any[] = [];
  expandedTrans: string[] = [];
  noneSelected: boolean = false;
  actionType: string = 'Bet';

  isTicketCreationTriggered: boolean = false;
  lastCreatedDirectRequest: PleasedModel.TicketDetail | null = null;
  triggerTicketRequestMap: { [key: string]: PleasedModel.ActiveTicket[] } = {};

  errInfo = {
    isErr: false,
    message: '',
  };

  get title () {
    if (this.lastCreatedDirectRequest) {
      return this.$t('page.issue.transaction.title.ticket_created', { ticketId: this.lastCreatedDirectRequest.id }).toString();
    }

    if (this.isNoRecord) {
      return this.$t('page.issue.transaction.none');
    }

    return `${this.$t('page.issue.bet.select_recent')}`;
  }

  get isNoRecord () {
    return this.transactions.length === 0;
  }
  get canProceed () {
    return this.selectedTransIssue.length || this.noneSelected || this.isNoRecord;
  }

  get selectedTransactionWithWarning () {
    return (this.selectedTransIssue || []).some((transaction) => checkBetTransactionWarning({
      transaction,
      chatWarnings: this.chatWarnings,
    }).show);
  }

  get triggerTicketCreation () {
    const { triggerTicketCreation } = this.connectConfig || {};

    return !!triggerTicketCreation && this.selectedTransIssue.length > 0;
  }

  get ticketCreationResponseMessage () {
    return this.connectConfig?.ticketCreationResponseMessage;
  }

  get triggerTicketCreationError () {
    if (!this.triggerTicketCreation) {
      return '';
    }

    const isSelectedTransactionAlreadyReported = this.selectedTransIssue.some((tx) => {
      const { shortId } = tx;
      return this.triggerTicketRequestMap[shortId]?.length > 0;
    });

    if (isSelectedTransactionAlreadyReported) {
      return this.$t('page.issue.transaction.duplicate_direct_ticket_error').toString();
    }

    return '';
  }

  get isSingleTransactionSelectMode () {
    const { triggerTicketCreation } = this.connectConfig || {};

    // if triggerTicketCreation is not set, then we don't need to check
    // for unsettled bet limitation (1 transaction per request)
    return triggerTicketCreation;
  }

  get buttons () {
    if (this.isTicketCreationTriggered) {
      if (this.errInfo.isErr) {
        return [
          {
            name: this.$t('global.end_chat'),
            id: 'end-chat',
            isActive: true,
          },
        ];
      }

      return [{
        // TODO: make separate row in i18n
        name: this.$t('article.feedback.button.need_more_help'),
        id: 'go-to-ticket',
        isActive: false,
        className: 'secondary',
      }, {
        name: this.$t('global.end_chat'),
        id: 'end-chat',
        isActive: true,
      }];
    }

    if (this.triggerTicketCreation) {
      if (this.triggerTicketCreationError) {
        return [
          {
            name: this.$t('global.end_chat'),
            id: 'end-chat',
            isActive: true,
          },
        ];
      }

      return [{
        name: this.$t('page.issue.transaction.submit_request'),
        id: 'direct-trigger-ticket-creation',
        isActive: true,
      }];
    }

    return [
      {
        name: this.selectedTransactionWithWarning ? this.$t('page.issue.transaction.proceed_anyway') : this.$t('page.guest.button.proceed'),
        id: 'proceed',
        isActive: true,
        className: this.selectedTransactionWithWarning ? 'secondary' : '',
      },
      ...(this.selectedTransactionWithWarning
        ? [
          {
            name: this.$t('page.issue.transaction.cancel_request'),
            id: 'cancel',
            isActive: true,
          },
        ]
        : []),
    ];
  }

  created () {
    document.title = 'Bet Transactions';
    fetch && fetch('@/assets/img/checked.svg'); // Preload the image

    if (this.transactionsSavedData) {
      this.selectedTransIssue = this.transactionsSavedData.selectedTransIssue;
    }
  }

  isTransactionSelected (transaction: BetHistoryEntity) {
    return this.selectedTransIssue.some((item) => item.shortId === transaction.shortId);
  }

  getTotalWinnings (trans: BetHistoryEntity) {
    const { winningStatus, totalWinnings } = trans;
    return winningStatus === 0 || winningStatus === 40 ? '--' : totalWinnings;
  }
  getReturnClass (trans: BetHistoryEntity) {
    const { winningStatus } = trans;
    if (winningStatus === 5 || winningStatus === 20) {
      return 'winnings';
    } else if (winningStatus === 30) {
      return 'losses';
    } else {
      return null;
    }
  }
  selectIssueTransactions (statement: BetHistoryEntity) {
    const index = this.selectedTransIssue.findIndex((trans) => trans.shortId === statement.shortId);
    const exist = index !== -1;

    if (exist) {
      this.selectedTransIssue.splice(index, 1);
    } else {
      this.noneSelected = false;

      if (this.isSingleTransactionSelectMode) {
        this.selectedTransIssue = [statement];
      } else {
        this.selectedTransIssue.push({ ...statement });
      }
    }
  }
  expandTrans (shortId: string) {
    const index = this.expandedTrans.indexOf(shortId);
    const exist = index !== -1;
    if (exist) {
      this.expandedTrans.splice(index, 1);
    } else {
      this.expandedTrans.push(shortId);
    }
  }
  selectNone () {
    if (this.noneSelected) {
      this.noneSelected = false;
    } else {
      this.selectedTransIssue = [];
      this.noneSelected = true;
    }
  }
  calculateOdds (trans: BetHistoryEntity) {
    if (trans.orderType === 1 && trans.selections.length === 1) {
      return round(+trans.selections[0].odds, 2);
    } else if (trans.orderType === 2) {
      const val = trans.selections.reduce((acc: number, curr: BetHistoryEntitySelection) => {
        return acc * +curr.odds;
      }, 1);
      return round(val, 2);
    }
    return false;
  }

  getSelectionIssueText (transaction: BetHistoryEntity) {
    return `${OrderType[transaction.orderType] || ''} ${this.actionType} (Id: ${transaction.shortId})`;
  }

  async directTriggerTicketCreation () {
    const { category, title } = this.connectConfig || {};
    const transactionId = this.selectedTransIssue[0].shortId;

    const openedTickets = await PleasedApi.getActiveConversations({ onlyActive: true, transactionId });

    if (openedTickets.tickets.length > 0) {
      Vue.set(this.triggerTicketRequestMap, transactionId, openedTickets.tickets);
      return;
    }

    reportingService.openRequestClicked();

    const transactionUserSelections = this.selectedTransIssue.map((tx) => ({
      timestamp: Date.now(),
      message: `${SYSTEM_MESSAGE_PREFIX} ${this.t('chat.user.issue.part')}: ${this.getSelectionIssueText(tx)}`,
    }));

    // For now we'll support only 1 transaction per request
    const subjectIds = `(Id${this.selectedTransIssue.length > 1 ? 's' : ''}: ${this.selectedTransIssue.map((tx) => tx.shortId).join(', ')})`;
    const subject = `${category} - ${title} - ${subjectIds}`;

    PleasedApi.createTicket({
      subject,
      description: 'Direct Ticket Creation Request',
      recipientAddress: this.requestInfo.email,
      ticketFields: this.openRequestFields,
      userSelections: [...this.userSelections, ...transactionUserSelections]
        .map(({ timestamp, message }) => ({ message, createdAt: `${timestamp}` })),
      userLogs: reportingService.getLogs(),
      tags: ['direct_ticket'],
      transactionId,
    }).then((res) => {
      this.lastCreatedDirectRequest = res;
      this.isTicketCreationTriggered = true;
      this.$emit('open-request', res.id);
    }).catch(e => {
      const error: Error = e;
      this.errInfo.isErr = true;
      this.errInfo.message = error.message;
    });
  }

  proceed (selectedButton: { id: string }) {
    if (selectedButton.id === 'cancel') {
      this.$emit('cancel:request', this.connectConfig);
      return;
    }

    if (selectedButton.id === 'end-chat') {
      this.$emit('end-chat');
      return;
    }

    if (selectedButton.id === 'direct-trigger-ticket-creation') {
      this.directTriggerTicketCreation();
      return;
    }

    if (selectedButton.id === 'go-to-ticket') {
      this.$emit('open-active-conversation', this.lastCreatedDirectRequest);
      return;
    }

    if (!this.canProceed) return;

    const issueMsg = this.selectedTransIssue.reduce((acc: string[], cur) => {
      const msg = this.getSelectionIssueText(cur);
      return [...acc, msg];
    }, []);

    const data = [{
      extraFieldKey: 'Transaction',
      extraFieldValue: this.selectedTransIssue.reduce((acc, cur) => {
        const msg = `${OrderType[cur.orderType]} ${this.actionType}: [${getTitile(cur.selections[0])}]`;
        return acc ? `${acc} / ${msg}` : `${msg}`;
      }, ''),
    }, {
      extraFieldKey: 'Transaction ID',
      extraFieldValue: this.selectedTransIssue.reduce((acc, cur) => acc ? `${acc} / ${cur.shortId}` : `${cur.shortId}`, ''),
    }];
    this.updateExtraTransactionInfo(data);

    const $event: TransactionInputEvent = { type: TransactionType.Bet, issues: issueMsg, none: this.noneSelected, meta: data, empty: this.isNoRecord, selectedTransIssue: this.selectedTransIssue };

    this.$emit('transaction:input', $event);
  }

  cleanErr () {
    this.errInfo.isErr = false;
    this.errInfo.message = '';
  }
}
